// extracted by mini-css-extract-plugin
export default {"mainCont":"GeoZoneLoad_mainCont__BiBOs","btnCont":"GeoZoneLoad_btnCont__QxN7e"};